'use client';

import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import type { CustomerReviewCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/CustomerReviewCardFragmentFragmentDoc';
import { mask } from '@packages/gql/src/betterMasking';
import { CustomerReviewCard } from '../../CustomerReviewCard/CustomerReviewCard.client';
import type { CreateReviewFormSchema } from '../AddReviewFormValidation/AddReviewFormValidation';
import { addReviewPreviewMessages } from './AddReviewPreview.messages';

/**
 * customer review preview
 */
export const AddReviewPreview = () => {
  const { formatMessage } = useIntl();

  const { watch } = useFormContext<CreateReviewFormSchema>();

  const { name, title, description, rating } = watch();

  return (
    <div>
      <div className="text-size-body-sm mb-2.5">{formatMessage(addReviewPreviewMessages.hint)}</div>
      <CustomerReviewCard
        data={mask<typeof CustomerReviewCardFragmentFragmentDoc>({
          // just to satisfy type
          id: 0,
          created: new Date().toLocaleDateString('de', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
          reviewer: { nickname: name },
          title: title || null,
          description,
          isVerified: false,
          isTranslated: false,
          responses: null,
          rating,
        })}
        hideActionsMenu
      />
    </div>
  );
};
